import { defineMessages, intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../box/box.jsx';
import Modal from '../../containers/modal.jsx';
import classNames from 'classnames';
import TagButton from '../../containers/tag-button.jsx';
import styles from './ymx-opus-share-modal.css';
import fx11 from './fx11.png';
import fx22 from './fx22.png';
import fx33 from './fx33.png';
import fx44 from './fx44.png';
import fx55 from './fx55.png';

import fx11Selected from './fx1.png';
import fx22Selected from './fx2.png';
import fx33Selected from './fx3.png';
import fx44Selected from './fx4.png';
import fx55Selected from './fx5.png';

const keyboardItems = [
    { id: 'key1', defaultSrc: fx11, selectedSrc: fx11Selected },
    { id: 'key2', defaultSrc: fx22, selectedSrc: fx22Selected },
    { id: 'key3', defaultSrc: fx33, selectedSrc: fx33Selected },
    { id: 'key4', defaultSrc: fx44, selectedSrc: fx44Selected },
    { id: 'key5', defaultSrc: fx55, selectedSrc: fx55Selected },
];

const messages = defineMessages({
    title: {
        defaultMessage: '作品发布',
        description: '作品发布',
        id: 'tw.opusShareModal.title'
    },
    allTag: {
        id: 'gui.library.allTag',
        defaultMessage: 'All',
        description: 'Label for library tag to revert to all items after filtering by tag.'
    }
});

const OpusShareModalComponent = props => (
    <Modal
        className={styles.modalContent}
        onRequestClose={props.onCancel}
        contentLabel={props.intl.formatMessage(messages.title)}
        id="usernameModal"
    >
        <Box className={styles.body}>
            <Box className={styles.itemBody}>
                作品名称
            <input
                    className={styles.textInput}
                    value={props.opusNameValue}
                    onChange={props.onOpusNameChange}
                    onFocus={props.onFocus}
                    onKeyPress={props.onKeyPress}
                    maxLength="15"
                    spellCheck="false"
                />
                <span className={styles.textCountLimit}>{props.opusNameValue.length}/15</span>
            </Box>
            <Box className={styles.itemBody}>
                作品介绍
                <textarea
                    className={styles.textTextarea}
                    placeholder={'快向其他小创客介绍一下你的作品吧！'}
                    value={props.introText}
                    onChange={props.onChangeIntroText}
                    maxLength="120"
                    spellCheck={false}
                />
                <span className={styles.textareaCountLimit}>{props.introText.length}/120</span>
            </Box>

            <Box className={styles.itemBody}>
                操作说明
                <textarea
                    className={styles.textTextarea}
                    placeholder={'这个作品怎么操作呢？快来给大家介绍一下吧！'}
                    value={props.operationText}
                    onChange={props.onChangeOperationText}
                    maxLength="120"
                    spellCheck={false}
                />
                <span className={styles.textareaCountLimit}>{props.operationText.length}/120</span>
            </Box>

            {props.tags && (
                <Box>
                    作品类型
                    <div className={styles.tagWrapper}>
                        {props.tags.map((tagProps, id) => (
                            <TagButton
                                active={props.selectedTags.includes(tagProps.tag.toLowerCase())}
                                className={classNames(
                                    styles.tagButton,
                                    tagProps.className
                                )}
                                key={`tag-button-${id}`}
                                onClick={() => {
                                    props.onTagClick(tagProps.tag);
                                }}
                                {...tagProps}
                            />
                            
                        ))}
                    </div>
                </Box>
            )}

            <Box>
            手机键盘
    <div className={styles.tagKeyboard}>
        {props.keyBoradType !== '5' ? (
            <img 
                className={styles.keyboardItem} 
                onClick={() => props.onChangekeyboardType('5')} 
                src={fx55} 
                alt="Keyboard 5"
            />
        ) : (
            <img 
                className={styles.keyboardItem} 
                onClick={() => props.onChangekeyboardType('0')} 
                src={fx55Selected} 
                alt="Keyboard 5 Selected"
            />
        )}
        {props.keyBoradType !== '1' ? (
            <img 
                className={styles.keyboardItem} 
                onClick={() => props.onChangekeyboardType('1')} 
                src={fx11} 
                alt="Keyboard 1"
            />
        ) : (
            <img 
                className={styles.keyboardItem} 
                onClick={() => props.onChangekeyboardType('0')} 
                src={fx11Selected} 
                alt="Keyboard 1 Selected"
            />
        )}
        {props.keyBoradType !== '2' ? (
            <img 
                className={styles.keyboardItem} 
                onClick={() => props.onChangekeyboardType('2')} 
                src={fx22} 
                alt="Keyboard 2"
            />
        ) : (
            <img 
                className={styles.keyboardItem} 
                onClick={() => props.onChangekeyboardType('0')} 
                src={fx22Selected} 
                alt="Keyboard 2 Selected"
            />
        )}
        {props.keyBoradType !== '3' ? (
            <img 
                className={styles.keyboardItem} 
                onClick={() => props.onChangekeyboardType('3')} 
                src={fx33} 
                alt="Keyboard 3"
            />
        ) : (
            <img 
                className={styles.keyboardItem} 
                onClick={() => props.onChangekeyboardType('0')} 
                src={fx33Selected} 
                alt="Keyboard 3 Selected"
            />
        )}
        {props.keyBoradType !== '4' ? (
            <img 
                className={styles.keyboardItem} 
                onClick={() => props.onChangekeyboardType('4')} 
                src={fx44} 
                alt="Keyboard 4"
            />
        ) : (
            <img 
                className={styles.keyboardItem} 
                onClick={() => props.onChangekeyboardType('0')} 
                src={fx44Selected} 
                alt="Keyboard 4 Selected"
            />
        )}
    </div>
            </Box>
            <Box className={styles.buttonRow}>
                {/* <button
                    className={styles.cancelButton}
                    onClick={props.onReset}
                >
                    <FormattedMessage
                        defaultMessage="Reset"
                        description="Button in username modal to reset username to random"
                        id="tw.usernameModal.reset"
                    />
                </button> */}
                {/* <button
                    className={styles.cancelButton}
                    onClick={props.onCancel}
                >
                    <FormattedMessage
                        defaultMessage="Cancel"
                        description="Button in prompt for cancelling the dialog"
                        id="gui.prompt.cancel"
                    />
                </button> */}
                <button
                    className={styles.okButton}
                    onClick={props.onOk}
                >
                    发 布
                </button>
            </Box>
        </Box>
    </Modal>
);

OpusShareModalComponent.propTypes = {
    intl: intlShape,
    selectedTags:PropTypes.arrayOf(PropTypes.string),
    keyBoradType: PropTypes.string,
    onChangekeyboardType:PropTypes.func,
    opusNameValue: PropTypes.string.isRequired,
    valueValid: PropTypes.bool.isRequired,
    introText: PropTypes.string,
    operationText: PropTypes.string,
    onOpusNameChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onTagClick: PropTypes.func.isRequired,
    onChangeIntroText: PropTypes.func,
    onChangeOperationText: PropTypes.func,
    tags: PropTypes.arrayOf(PropTypes.shape(TagButton.propTypes)),
};

export default injectIntl(OpusShareModalComponent);